module.exports = __webpack_public_path__ + "img/comment.cf646eff.svg";